import React, { Component } from 'react';
import classNames from 'classnames';
import ImageWithFallback from '@liveauctioneers/caterwaul-components/lib/ImageWithFallback/ImageWithFallback';
import noop from '../../utils/noop';
import styles from './ImageWithHover.module.scss';

type Props = {
    alt: string,
    blurPlaceholder: boolean,
    className: string,
    forceFallback: boolean,
    onClick: Function,
    onLoad: Function,
    placeholder: string,
    skipVisibilityCheck: boolean,
    srcPrimary: boolean,
    srcSecondary: boolean,
    style: Object,
};

type State = {
    primaryError: boolean,
    secondaryError: boolean,
};

export default class ImageWithHover extends Component<Props, State> {
    static defaultProps = {
        alt: '',
        blurPlaceholder: false,
        className: '',
        forceFallback: false,
        onClick: noop,
        onLoad: noop,
        placeholder: '',
        skipVisibilityCheck: false,
        srcPrimary: '',
        srcSecondary: '',
        style: {},
    };

    state = {
        primaryError: false,
        secondaryError: false,
    };

    handlePrimaryError = () => {
        this.setState({ primaryError: true });
    };

    handleSecondaryError = () => {
        this.setState({ secondaryError: true });
    };

    render() {
        const {
            alt,
            blurPlaceholder,
            className,
            forceFallback,
            onClick,
            onLoad,
            placeholder,
            skipVisibilityCheck,
            srcPrimary,
            srcSecondary,
            style,
        } = this.props;

        const { primaryError, secondaryError } = this.state;

        let primaryClass =
            Boolean(srcSecondary) && !secondaryError ? classNames([className, styles['img-primary']]) : className;
        const secondaryClass = classNames([className, styles['img-secondary']]);
        let source = srcPrimary ? srcPrimary : srcSecondary;
        let showSingleImage = false;

        if (primaryError) {
            if (!secondaryError) {
                showSingleImage = true;
                source = srcSecondary;
            }
        }

        if (secondaryError) {
            if (!primaryError) {
                showSingleImage = true;
                source = srcPrimary;
            }
        }

        return showSingleImage ? (
            <div>
                <ImageWithFallback
                    alt={alt}
                    blurPlaceholder={blurPlaceholder}
                    className={className}
                    forceFallback={forceFallback}
                    onClick={onClick}
                    onLoad={onLoad}
                    placeholder={placeholder}
                    skipVisibilityCheck={skipVisibilityCheck}
                    src={source}
                    style={style}
                />
            </div>
        ) : (
            <div className={styles['image-container']}>
                <ImageWithFallback
                    alt={alt}
                    blurPlaceholder={blurPlaceholder}
                    className={secondaryClass}
                    forceFallback={forceFallback}
                    onClick={onClick}
                    onLoad={onLoad}
                    onError={this.handleSecondaryError}
                    placeholder={placeholder}
                    skipVisibilityCheck={skipVisibilityCheck}
                    src={srcSecondary}
                    style={style}
                />
                <ImageWithFallback
                    alt={alt}
                    blurPlaceholder={blurPlaceholder}
                    className={primaryClass}
                    forceFallback={forceFallback}
                    onClick={onClick}
                    onLoad={onLoad}
                    onError={this.handlePrimaryError}
                    placeholder={placeholder}
                    skipVisibilityCheck={skipVisibilityCheck}
                    src={source}
                    style={style}
                />
            </div>
        );
    }
}
